var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.alertUser.show)?_c('Alert',{key:NaN,attrs:{"type":_vm.alertUser.type,"text":_vm.alertUser.text,"snackbarVal":_vm.alertUser.show},on:{"snackbarClicked":function($event){return _vm.$store.commit('alertUser', { show: false, text: '', type: '' })}}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }